import {
  Component,
  ViewChild,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { ModalComponent } from "../../../components/modal/modal.component";
import { TopLevelFieldMapping } from "../../../models/top-level-field-mapping.model";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import * as _ from "underscore";
import { MetaDataMapping } from "../../../models/meta-data.model";

@Component({
  selector: "lowy-select-genetic-columns",
  template: `
    <lowy-modal #modal>
      <div class="form">
        <div class="headline">Select Genetic Columns</div>
        <div class="subheading">
          Select columns to view in genetic search grid.
        </div>
        <div class="seperator"></div>

        <div class="checkboxes">
          <mat-checkbox
            *ngFor="let column of geneticColumns"
            [(ngModel)]="selectedColumns[column.metaDataMappingId]"
            class="checkbox"
            >{{ column.columnName }}</mat-checkbox
          >
        </div>

        <div class="seperator"></div>
        <div class="button-row">
          <span (click)="cancel()">cancel</span>
          <span (click)="save()">save</span>
        </div>
      </div>
    </lowy-modal>
  `,
  styles: [
    `
      .seperator {
        margin-bottom: 15px;
      }
    `,
  ],
})
export class SelectGeneticColumnsComponent {
  @ViewChild("modal") modal: ModalComponent;

  public selectedColumns: { [metaDataMappingId: number]: boolean } = {};

  @Input("geneticColumns") geneticColumns: MetaDataMapping[];

  @Output() setColumns: EventEmitter<any>;

  constructor() {
    this.setColumns = new EventEmitter();
  }

  public open(columns?: MetaDataMapping[]) {
    this.modal.open();
    // TODO
    // if (columns) {
    //   this.columnsToAdd = columns;
    // } else {
    //   this.columnsToAdd = [];
    // }
  }

  clearAll() {
    this.selectedColumns = {};
  }

  save() {
    const columnToSet = [];
    _.each(this.geneticColumns, (col) => {
      if (this.selectedColumns[col.metaDataMappingId]) {
        columnToSet.push(col);
      }
    });
    this.setColumns.emit(columnToSet);
    this.modal.close();
  }

  cancel() {
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/search/search-modals/select-genetic-columns-modal.component.ts